import React from "react";
import { useSelector } from "react-redux";
import {  Grid, Label  } from "semantic-ui-react";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import InputField from "../../../../commonComponents/formComponents/inputField";
import { Country } from "../../../../commonComponents/dropdown/country";
import { selectCountryList008, selectCountryList199, selectMot } from "../../../selectors";
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";
import { TranslateContext } from "../../TranslateContext";
import { placeKey,incotermKey, descriptionKey } from "../../../util/NL_fieldPatterns";

const displayError=(value)=>{
  if(!value) return null
 return(
   <PopUpIcon style={{"display": "inline"}}
         color="red" icon="exclamation triangle circle"
         popupText={ <div className="error">* {value}</div>} />
 
 )
}
const isValueXXX=(value)=>value=="XXX"
const TradeTermsForm=({dataSource,onUpdate,saveData,errorInfo:{placeError,incotermError,descriptionError},isDMS,isImportShipment,validateError,fieldPattern,saveForm})=>{

  const {description,incoTerms,unloc,location,country,place,relationship}=dataSource
  const incoTermsList=useSelector((state) => state.DropDownValues.incoTerms);
  const relationshipCodes=useSelector((state) => state.DropDownValues.relationshipCodes);

  const CountryList=useSelector(isImportShipment ? selectCountryList199 : selectCountryList008);
  const mot=useSelector(selectMot)

  const translate = React.useContext(TranslateContext).translate

  const incoTermWarning=React.useMemo(()=>{
    const selectedIncoTerms=incoTermsList.find((item)=>item.value==incoTerms)
    if(selectedIncoTerms?.mot)
       return selectedIncoTerms?.mot?.includes(mot) ? "" :`Mot in border transit should be  ${selectedIncoTerms.mot.join('or')},If incoterms selected is for Seafreight`
      else
        return ""
   
  },[mot,incoTerms,incoTermsList])

  const getPattern=React.useCallback((value,additionalPatterns={})=>({[placeKey]:fieldPattern({isValueXXX:value})?.header[placeKey],...additionalPatterns}),[isValueXXX,incoTerms])
 
  return (
    <React.Fragment>
         <Grid.Row className={`theme-textbox ${isDMS ? 'border-b-0' :''}`}>
              <label className="label-address">  {translate("TRADE_TERMS", {ns:["default", "lineItem"]})}</label>
             
              <Grid.Column className="row"
               width="4"  >
                  
                <Label className="title">
                {
                  displayError(incotermError || incoTermWarning)
                 }
                  INCOTERMS
                  </Label>
                
                <DropDown
                id="incoTerms" 
                className="field-bg dropdown100 theme-dropdown"
                labelClass="text-none"
                isLabel={false}
                data={incoTermsList}
                value={incoTerms}
                clearable
                onChange={(value)=>{
                    const description=isValueXXX(value)? "":incoTermsList.find(c=>c.value==value)?.text
                    onUpdate({incoTerms:value?.trim(),description:description || ""})
                    saveData({incoTerms:value,description:description || " "})
                    validateError(
                      {[`${placeKey}`]:"",[`${incotermKey}`]:"",[`${descriptionKey}`]:""}
                      ,{transportation:{tradeTerms:{place,incoTerms:value?.trim(),description}}},
                      getPattern(value?.trim(),{[incotermKey]:fieldPattern()?.header[incotermKey],[descriptionKey]:fieldPattern({isValueXXX:value?.trim()})?.header[descriptionKey]}))
                  
                }}
               
        />
                
              </Grid.Column>
              
              <Grid.Column width={isDMS ? "12" :"4"} className="row" >
              <Label className="disabled title">
                {displayError(descriptionError)}
                {translate("DESCRIPTION", {ns:["default", "header"]})}
                </Label>
              <InputField
                  isLabel={false}
                  isFooterLabel={true}
                  disabled={!isValueXXX(incoTerms)}
                  type="text"
                  id="description"
                  className="field-bg"
                  clearInput={false}
                  name="description"
                  onChange={(value)=>onUpdate({"description":value})}
                  onBlur={(value) =>{
                    saveData({description:description || " "})
                    validateError({[`${descriptionKey}`]:""},{transportation:{tradeTerms:{description}}},{[descriptionKey]:fieldPattern({isValueXXX:incoTerms})?.header[descriptionKey]})
                  }
                  }
                  value={description}
                  
                />
              </Grid.Column>
             
              {
              !isDMS && 
              <React.Fragment>
            <Grid.Column className="row"
               width="4"
              >
                <Label className="title">
                   {displayError(placeError)} 
                  {translate("PLACE", {ns:["default", "header"]})}
                  </Label>
                <InputField
                  isLabel={false}
                  isFooterLabel={true}
                  id="place"
                  type="text"
                  className="field-bg"
                  clearInput={false}
                  extraParams={incoTerms}
                  name="place"
                  onChange={(value)=>onUpdate({"place":value})}
                  onBlur={(value) =>{
                    saveData({place:place || " "})
                    validateError({[`${placeKey}`]:""},{transportation:{tradeTerms:{place:value}}},getPattern(incoTerms))
                  }}
                  value={place}
                 
                />
              </Grid.Column>
              
              <Grid.Column className="row" 
              width="4" >
              <Label className="disabled title">{translate("RELATIONSHIP", {ns:["default", "lineItem"]})}</Label>
              <DropDown
                id="relationship" 
                direction="left"
                className="field-bg dropdown100 theme-dropdown"
                labelClass="text-none"
                isLabel={false}
                data={relationshipCodes}
                value={relationship}
                clearable
                onChange={(value)=>{
                  onUpdate({"relationship":value?.trim()})
                  saveData({relationship:value})
                }}
                
        />
              </Grid.Column>
              </React.Fragment>
              
                          }
            
            </Grid.Row> 
            
            {
              isDMS && <Grid.Row  className="theme-textbox">
            
            <Grid.Column className="row"
               width="6"
               style={{position:'relative',bottom:'10px'}}
              >
                <Label className="title">{translate("UNLOC", {ns:["default", "header"]})}</Label>
                <DropDown
                id="unloc" 
                className="field-bg dropdown100 theme-dropdown"
                labelClass="text-none"
                isLabel={false}
                data={[]}
                value={unloc}
                clearable
                onChange={(value)=>{
                  onUpdate({unloc:value?.trim()})
                  saveData({unloc:value})
                }}
                
        />
               
              </Grid.Column>
              
              <Grid.Column className="row" style={{position:'relative',bottom:'10px'}} width="5" >
              <Label className="disabled title">{translate("LOCATION")}</Label>
              <InputField
                  isLabel={false}
                  isFooterLabel={true}
                  id="location"
                  type="text"
                  className={"field-bg"}
                  clearInput={false}
                  name="location"
                  onChange={(value)=>onUpdate({"location":value})}
                  onBlur={(value) =>saveData({location:location || " "})}
                  value={location}
                 
                />
              </Grid.Column>
              
              <Grid.Column  className="row" style={{position:'relative',bottom:'10px'}} width="5">
              <Label className="disabled title">{translate("COUNTRY", {ns:["default", "parties"]})}</Label>
              <Country
                id="tradeTermsCountry"
                value={country}
                className="theme-dropdown"
                dataSource={CountryList}
                onChange={(value)=>onUpdate({"country":value})}
                onBlur={(value) =>saveData({country})}
              />
             
         
              </Grid.Column>
              
              </Grid.Row>
}
    </React.Fragment>
  );
}
TradeTermsForm.defaultProps={
    dataSource:{},
    errorInfo:{}
}
export default React.memo(TradeTermsForm)
